// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ArrowRightComponent} from './ArrowRight.svg';

import Icon, { TIconProps } from '../Icon';

export const IconArrowRight = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ArrowRightComponent/>
  </Icon>
));
